import Moment from 'moment'

export const feeTypes = [
  {
    value: 'Session',
    label: 'Billed by the session',
  },
  {
    value: 'Hourly',
    label: 'Billed by the hour',
  },
]

export const feeIsHourly = val => val === 'Hourly'

export const sessionTemplate = ({ sessions, careEnrolmentOptions = [] }) => (
  index = 0,
  { dayIndex }
) => {
  const sessionDay = String(dayIndex)
  if (sessions && sessions['1'] && sessions['1'][index])
    return Object.assign({}, { ...sessions['1'][index] }, { sessionDay })

  return {
    startTime: '09:00:00',
    endTime: '17:00:00',
    standardAmount: '0',
    care_id: defaultCareID(careEnrolmentOptions),
    sessionDay,
    feeFrequency: feeTypes[0].value,
  }
}

export const defaultCasualSession = (careEnrolmentOptions = []) => {
  return {
    care_id: defaultCareID(careEnrolmentOptions), 
    startTime: '09:00:00', 
    endTime: '17:00:00', 
    standardAmount: '0',
    feeFrequency: feeTypes[0].value,
  }
}

const defaultCareID = (careEnrolmentOptions = []) => {
  const enrolment = careEnrolmentOptions[0] || {}
  return enrolment.value
}

export const isFortnightlyPattern = ({ week2 }) => ![null, undefined].includes(week2)

// Not sure how i feel about using JSON
// https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
export const duplicateWeek = (week = {}) => JSON.parse(JSON.stringify(week)) 

export const timePattern = 'HH;mm:ss'

const maxSessionLengthInMinutes = 12 * 60 // 12 hours

export const valdiateSessionLength = ({ startTime, endTime }) => {
  if (!startTime || !endTime) {
    return true
  }

  const start = Moment(startTime, timePattern)
  const end = Moment(endTime, timePattern)

  return Math.abs(start.diff(end, 'minutes')) <= maxSessionLengthInMinutes
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/form/helpers.js